import { makeStyles } from '@lifeomic/chroma-react/styles';

export const useModalStyles = makeStyles(() => ({
  modalContent: {
    padding: 0,
  },
  img: {
    maxWidth: '100%',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
}));
